import BookingCheckinDataBox from '../features/checkInOut/BookingCheckinDataBox';

function BookingCheckin() {
  return <BookingCheckinDataBox />;
}

export default BookingCheckin;
